import { ReactNode } from 'react';
import { OverlaySpinner } from '@ankr.com/ui';

import { useAuthInstance } from '../../hooks/useAuthInstance';

export interface LogginInGuardProps {
  children: ReactNode;
  fallback: ReactNode;
}

export const LoggingInGuard = ({ children, fallback }: LogginInGuardProps) => {
  const { isInitialized, isSignedIn } = useAuthInstance();

  if (!isInitialized) {
    return <OverlaySpinner />;
  }

  return isSignedIn ? children : fallback ?? null;
};
